export const whatWeDoText =
  "As members of a larger technical community, IEEE RVCE aims to connect future engineers and researchers with industry experts and top academicians. We provide a platform for students to stay updated with today's research through webinars and technical talks by eminent professors and professionals. We also arrange workshops and Industrial visits that help students upgrade their skills to stay relevant in today's global market.";
export const SbachievementsText = [
  'Circuits and Systems Society Society - Outstanding Student Chapter Award 2024',
  'Power and Energy Society Society - Outstanding Student Chapter Award 2024',
  'IEEE Bangalore Section-Outstanding Student Branch Digital Presence Award 2023',
  'IEEE R10 - Exemplary Student Branch Award - 2022',
  'Winner - Global Student Branch Website Contest 2021',
  'Second Runner Up in Student Branch Website Contest - IEEE R10 SAC 2021',
  'SPS Student Branch Chapter Growth Reward - Received 3 times',
  'IEEE Bangalore Section MDC Award - 2021',
  'Outstanding Medium Student Branch 2020: IEEE Bangalore Section',
  'IEEE CS Bangalore Chapter - Outstanding CS Student Chapter Award 2020',
  'Third position in Membership Development Challenge Awards 2020',
];

export const MemAchivementText = [
  'IEEE Bangalore Section Outstanding Student Volunteer 2023 : Nisarga V',
  'IEEE India Council Outstanding Student Volunteer - 2021 : S J Ruthvik',
  'IEEE Bangalore Section Outstanding Student Volunteer - 2021 : Risha Dassi',
  'Best Teacher Award - 2020: Mahesh Appajappa',
  'Best Researcher Award - 2020: Dr.Shylashree N',
  'Top Performer Award ( Jan-Jun 2020) IEEE Bangalore Section - Raghavendra Prasad',
  'Branch Counselors of Nov-Dec 2020: Dr. Ashok Kumar A R',
  'Outstanding Student Volunteer Award - 2020: S J Ruthvik',
  'Best SAC Volunteer Award - 2020: S J Ruthvik',
];
